export const ROOT = 'district';

export const FETCH_DISTRICT_REQUEST = `${ROOT}/FETCH_DISTRICT_REQUEST`;
export const FETCH_DISTRICT_FAILURE = `${ROOT}/FETCH_DISTRICT_FAILURE`;
export const FETCH_DISTRICT_SUCCESS = `${ROOT}/FETCH_DISTRICT_SUCCESS`;

export const SET_DISTRICT_FULLDATA = `${ROOT}/SET_DISTRICT_FULLDATA`;
export const SET_DISTRICT_MESSAGE = `${ROOT}/SET_DISTRICT_MESSAGE`;
export const SET_DISTRICT_INPUT_VALUE = `${ROOT}/SET_DISTRICT_INPUT_VALUE`;

export const CLEAR_DISTRICT_FULLDATA = `${ROOT}/CLEAR_DISTRICT_FULLDATA`;
export const CLEAR_DISTRICT_DATA = `${ROOT}/CLEAR_DISTRICT_DATA`;
export const CLEAR_DISTRICT_MESSAGE = `${ROOT}/CLEAR_DISTRICT_MESSAGE`;
export const CLEAR_DISTRICT_INPUT_VALUE = `${ROOT}/CLEAR_INPUT_VALUE`;
